export class IntroductionMessages {
  public libelle = 'introduction.libelle';
  public paragrapheA = 'introduction.paragrapheA';
  public paragrapheB = 'introduction.paragrapheB';
  public paragrapheC = 'introduction.paragrapheC';
  public paragrapheD = 'introduction.paragrapheD';


  constructor() {
  }
}
